import React from 'react';

import StinkNewsletterForm from './StinkNewsletterForm';

const StinkNewsletter = () => {
  return (
    <div className="grid grid-cols-12 bg-creme">
      <div className="p-6 col-span-full sm:col-span-5 lg:col-span-full">
        <h4 className="stink-h4">Subscribe</h4>
        <p className="mt-2 stink-body-2">Get stories delivered weekly.</p>
      </div>

      <div className="pt-6 pb-6 pl-6 pr-6 sm:pl-0 lg:pl-6 lg:col-span-full col-span-full sm:col-span-7">
        <StinkNewsletterForm placeholder="Enter your email" />
      </div>
    </div>
  );
};

export default StinkNewsletter;
